import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const commitments = ['Strict adherence to the Fair Debt Collection Practices Act (FDCPA)', 'Compliance with the Telephone Consumer Protection Act (TCPA)', 'Fair Credit Reporting Act (FCRA) compliant data handling', 'Regular staff training on ethical collection practices', 'Secure, encrypted management of sensitive consumer data', 'Respectful, solution-oriented communication with consumers'];
export function Compliance() {
  return <section id="compliance" className="py-24 bg-brand-navy text-white" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-125">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-126">
              Uncompromising Ethics & Compliance
            </h2>
            <p className="text-blue-100 text-lg mb-8 leading-relaxed" data-id="element-127">
              We understand that when we contact a consumer, we are representing
              your business. That's why compliance isn't just a department at
              Compass Recovery Group—it's the foundation of our entire
              operational model.
            </p>
            <p className="text-blue-100 text-lg leading-relaxed" data-id="element-128">
              We treat every consumer with dignity and respect, focusing on
              collaborative resolution rather than confrontation. This ethical
              approach not only protects your brand but consistently yields
              higher recovery rates.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl" data-id="element-129">
            <h3 className="text-xl font-bold mb-6 border-b border-white/20 pb-4" data-id="element-130">
              Our Compliance Commitments
            </h3>
            <ul className="space-y-4" data-id="element-131">
              {commitments.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-132">
                  <CheckCircle2 className="text-brand-red shrink-0 mt-0.5" size={20} data-id="element-133" />
                  <span className="text-blue-50 leading-snug" data-id="element-134">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}